import CourseCreationContainer from '../CoursesCreationContainer/steps/course-creation';

export default CourseCreationContainer;